// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/check-circle.svg. Do not edit.

import type { Glyph } from '../../types'

export const glyph: Glyph = {
  name: 'check-circle',
  version: 'outline',
  paths: [
    {
      d: 'M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z',
    },
  ],
}
